<template>
  <div>
    <!-- <v-touch @swipeup="swiperup" @swipedown="swiperdown" @swipeleft="swiperleft" @swiperight="swiperright"> -->
    <div v-show="isTitle"
      style="padding: 0 18px;display: flex;justify-content: space-between;align-items: center;height: 60px;width: 100%;position: fixed;top: 0;left: 0;box-sizing: border-box;background: #fff;z-index: 99;box-shadow: rgb(87 138 255 / 10%) -6px 2px 17px 0px">
      <img src="../assets/mobile/logo2.png" style="width: 122px;height: 34px;">
      <img style="width: 150px;cursor: pointer;" src="https://open.work.weixin.qq.com/service/img?id=ww1ec99764ed843f3f&t=isp&c=white&s=large" srcset="https://open.work.weixin.qq.com/service/img?id=ww1ec99764ed843f3f&t=isp&c=white&s=large@2x 2x" referrerpolicy="unsafe-url" alt="企业微信">
    </div>
    <div style="height: 60px;"></div>
    <div class="banner" :style="{'background': 'url(' + baseURL + mk1.mobileImg + ')','background-repeat':'no-repeat','background-size':'cover'}">
      <div style="width: 330px;margin: 0 auto;text-align: center;">
        <div
          style="font-size: 32px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 45px;">
          {{mk1.title}}
        </div>
        <div
          style="font-size: 22px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 45px;">
          {{mk1.subtitle}}
        </div>
        <div style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #B6CBFF;line-height: 24px;">
          {{mk1.content}}
        </div>
        <div
          style="width: 132px;height: 44px;background: linear-gradient(to bottom right, #02B4E0 40%, #14E1A0 99%);border-radius: 25px;border: 1px solid #216DF4;line-height: 44px;text-align: center;color: #fff;margin: 35px auto 0;"
          @click="show = true">
          立即咨询
        </div>
      </div>
    </div>
    <div>
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;color: #36444D;line-height: 37px;margin: 50px auto;text-align: center;">
        基于国家标识的智能获客<br />营销系统
      </div>
      <div class="iconList">
        <div>
          <img src="../assets/mobile/icon_zn@2x.png" style="width: 56px;height: 56px;">
          <div>智能名片</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_crm@2x.png" style="width: 56px;height: 56px;">
          <div>SCRM管理</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_fg@2x.png" style="width: 56px;height: 56px;">
          <div>复购商城</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_zh@2x.png" style="width: 56px;height: 56px;">
          <div>智慧防伪</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_fc@2x.png" style="width: 56px;height: 56px;">
          <div>防窜管理</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_ai@2x.png" style="width: 56px;height: 56px;">
          <div>AI数据分析</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_fx@2x.png" style="width: 56px;height: 56px;">
          <div>分销追踪</div>
        </div>
        <div>
          <img src="../assets/mobile/icon_fk@2x.png" style="width: 56px;height: 56px;">
          <div>访客追踪</div>
        </div>
      </div>
    </div>
    <div style="text-align: center;margin-top: 20px;">
      <img src="../assets/mobile/yxxt@2x.png" style="width: 352px;height: 212px;">
    </div>
    <div>
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #36444D;line-height: 37px;text-align: center;margin: 50px auto;">
        {{mk3.title}}</div>
      <div style="display: flex;justify-content: space-between;padding: 0 16px;">
        <div style="font-size: 17px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #36444D;">{{mk3.subtitle}}
        </div>
        <div style="display: flex;align-items: center;" @click="show = true">
          <span
            style="font-size: 13px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #22BEC5;">{{mk3.buttonName}}</span><span
            style="color: #22BEC5;display: inline-block;margin-left: 5px;margin-bottom: 2px;">></span>
        </div>
      </div>
      <div
        style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 22px;padding: 0 16px;margin-top: 12px;color: #707885;">
        {{mk3.content}}
      </div>
      <div style="text-align: center;margin: 40px 0"><img src="../assets/mobile/gjgxb@2x.png"
          style="width: 318px;height: 168px;"></div>
    </div>
    <div style="height: 449px;background: #F5F5F8;padding-top: 45px;">
      <div style="display: flex;justify-content: space-between;padding: 0 16px;">
        <div style="font-size: 17px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #36444D;">
          {{mk4.title}}
        </div>
        <div style="display: flex;align-items: center;" @click="show = true">
          <span
            style="font-size: 13px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #22BEC5;">{{mk4.buttonName}}</span><span
            style="color: #22BEC5;display: inline-block;margin-left: 5px;margin-bottom: 2px;">></span>
        </div>
      </div>
      <div
        style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #767D8A;line-height: 22px;padding: 0 16px;margin: 12px 0;height: 84px;">
        {{mk4.content}}
      </div>
      <div style="text-align: center;margin: 25px 0;">
        <img src="../assets/mobile/fwzl@2x.png" style="width: 303px;height: 236px;">
      </div>
    </div>
    <div style="padding-top: 45px;">
      <div style="display: flex;justify-content: space-between;padding: 0 16px;">
        <div style="font-size: 17px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #36444D;">
          {{mk5.title}}
        </div>
        <div style="display: flex;align-items: center;" @click="show = true">
          <span
            style="font-size: 13px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #22BEC5;">{{mk5.buttonName}}</span><span
            style="color: #22BEC5;display: inline-block;margin-left: 5px;margin-bottom: 2px;">></span>
        </div>
      </div>
      <div
        style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 22px;padding: 0 16px;margin-top: 12px;color: #707885;">
        {{mk5.content}}
      </div>
      <div style="text-align: center;margin: 40px 0"><img src="../assets/mobile/lbfg@2x.png"
          style="width: 246px;height: 246px;"></div>
    </div>

    <div style="background: linear-gradient(180deg, #FFFFFF 0%, #F5F5F8 100%);padding-bottom: 30px;">
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #36444D;line-height: 37px;text-align: center;margin: 50px auto;">
        日化标识码全力提升企业<br />开源节流能力</div>
      <div style="text-align: center;margin: 40px 0"><img src="../assets/mobile/lx_t@2x.png"
          style="width: 326px;height: 169px;"></div>
      <div
        style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #36444D;line-height: 37px;text-align: center;margin: 50px auto;">
        一物一码，让产品流向有据可查备份</div>
      <div style="text-align: center;margin: 40px 0"><img src="../assets/mobile/sj_t@2x.png"
          style="width: 310px;height: 165px;"></div>
      <div
        style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #1F2329;line-height: 32px;text-align: center;">
        让数据更可视化，实现产品的全生命周期管理</div>
    </div>
    <div style="height: 400px;">
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #1F2329;line-height: 37px;text-align: center;margin: 60px 0 30px;">
        他们都在用日化标识码</div>
      <div style="height: 400px;">
        <!-- <div
          style="margin: 0 20px;box-sizing: border-box;box-shadow: 0px 2px 10px 0px rgba(193, 194, 224, 0.5);height: 260px;overflow: hidden;padding: 23px 16px 18px 13px;position: relative;"> -->
        <div
          style="margin: 0 20px;box-sizing: border-box;height: 400px;overflow: hidden;padding: 23px 16px 18px 13px;position: relative;">
          <van-swipe class="my-swipe" indicator-color="white">
            <van-swipe-item>
              <div style="box-shadow: 0px 2px 10px 0px rgba(193, 194, 224, 0.5);padding: 12px;border-radius: 10px;">
                <div style="display: flex;justify-content: space-between;">
                  <img src="../assets/images/luanna.png" style="width: 76px;height: 76px;">
                  <img src="../assets/mobile/yinhao@2x.png" style="width: 22px;height: 18px;margin: 20px 20px 0 0 ;">
                </div>

                <div style="font-size: 14px;font-family: AppleSystemUIFont;color: #1E232A;line-height: 30px;">
                  日化标识码是一款一站式全流程防伪营销， 数据管理全面实现开源节流。 日化标识码，定义新的营销方式。</div>
                <div
                  style="text-align: right;font-size: 14px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1D232B;line-height: 28px;padding-right: 10px;">
                  — 张教授 潞安娜销售总监</div>
              </div>

            </van-swipe-item>
            <van-swipe-item>
              <div style="box-shadow: 0px 2px 10px 0px rgba(193, 194, 224, 0.5);padding: 12px;border-radius: 10px;">
                <div style="display: flex;justify-content: space-between;">
                  <img src="../assets/images/xitai.png" style="width: 76px;height: 76px;">
                  <img src="../assets/mobile/yinhao@2x.png" style="width: 22px;height: 18px;margin: 20px 20px 0 0 ;">
                </div>
                <div style="font-size: 14px;font-family: AppleSystemUIFont;color: #1E232A;line-height: 30px;">
                  皙肽的每一件产品都赋予了工信部授权的一物一码标识码，帮助企业进行获客以及精细化运营，从而促进业务增长。</div>
                <div
                  style="text-align: right;font-size: 14px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1D232B;line-height: 28px;padding-right: 10px;">
                  — 中国日用化学工业研究院</div>
              </div>

            </van-swipe-item>
            <van-swipe-item>
              <div style="box-shadow: 0px 2px 10px 0px rgba(193, 194, 224, 0.5);padding: 12px;border-radius: 10px;">
                <div style="display: flex;justify-content: space-between;">
                  <img src="../assets/images/hanguan.png" style="width: 76px;height: 76px;">
                  <img src="../assets/mobile/yinhao@2x.png" style="width: 22px;height: 18px;margin: 20px 20px 0 0 ;">
                </div>
                <div style="font-size: 14px;font-family: AppleSystemUIFont;color: #1E232A;line-height: 30px;">
                  BOSS端管理APP解决了多年来数据无法追溯的问题，未来，他可以领航美业防伪营销数据管理一体化。</div>
                <div
                  style="text-align: right;font-size: 14px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1D232B;line-height: 28px;padding-right: 10px;">
                  — 韩冠生物CEO</div>
              </div>

            </van-swipe-item>
          </van-swipe>
          <img src="../assets/mobile/list@2x.png"
            style="width: 66px;height: 32px;position: absolute;right: 35px;bottom: 125px;z-index: -1;">
        </div>
      </div>
    </div>
    <div class="sj">
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 37px;color: #fff;margin: 42px 0 52px;">
        数据助推增长</div>
      <div class="sjBanner">
        <div style="display: flex;justify-content: space-between;height: 100px;align-items: center;">
          <div style="text-align: center;position: relative;">
            <span style="font-size: 50px;font-weight: 500;line-height: 61px;">{{num1}}</span>
            <span
              style="font-size: 16px;font-family: DINAlternate-Bold, DINAlternate;font-weight: bold;line-height: 19px;position: absolute;right: 20px;top: 10px;">%</span>
            <img src="../assets/mobile/jt_1@2x.png" style="width: 23px;height: 36px;margin-left: 5px;">
            <div
              style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #3C424C;line-height: 17px;">
              用户扫码率增长
            </div>
          </div>
          <div style="text-align: center;position: relative;">
            <span style="font-size: 50px;font-weight: 500;line-height: 61px;">{{num2}}</span>
            <span
              style="font-size: 16px;font-family: DINAlternate-Bold, DINAlternate;font-weight: bold;line-height: 19px;position: absolute;right: 20px;top: 10px;">%</span>
            <img src="../assets/mobile/jt_1@2x.png" style="width: 23px;height: 36px;margin-left: 5px;">
            <div
              style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #3C424C;line-height: 17px;">
              GMV增长
            </div>
          </div>
        </div>
        <div style="text-align: center;height: 100px;display: flex;align-items: center;justify-content: center;">
          <div style="text-align: center;position: relative;">
            <span style="font-size: 50px;font-weight: 500;line-height: 61px;">{{num3}}</span>
            <span
              style="font-size: 16px;font-family: DINAlternate-Bold, DINAlternate;font-weight: bold;line-height: 19px;position: absolute;right: 20px;top: 10px;">%</span>
            <img src="../assets/mobile/jt_1@2x.png" style="width: 23px;height: 36px;margin-left: 5px;">
            <div
              style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #3C424C;line-height: 17px;">
              会员增长
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: space-between;height: 100px;align-items: center;">
          <div style="text-align: center;position: relative;">
            <span style="font-size: 50px;font-weight: 500;line-height: 61px;">{{num4}}</span>
            <span
              style="font-size: 16px;font-family: DINAlternate-Bold, DINAlternate;font-weight: bold;line-height: 19px;position: absolute;right: 20px;top: 10px;">%</span>
            <img src="../assets/mobile/jt_1@2x.png" style="width: 23px;height: 36px;margin-left: 5px;">
            <div
              style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #3C424C;line-height: 17px;">
              复购率增长
            </div>
          </div>
          <div style="text-align: center;position: relative;">
            <span style="font-size: 50px;font-weight: 500;line-height: 61px;">{{num5}}</span>
            <span
              style="font-size: 16px;font-family: DINAlternate-Bold, DINAlternate;font-weight: bold;line-height: 19px;position: absolute;right: 20px;top: 10px;">%</span>
            <img src="../assets/mobile/jt_2@2x.png" style="width: 28px;height: 29px;margin-left: 5px;">
            <div
              style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #3C424C;line-height: 17px;">
              人工成本降低
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 325px;">
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #36444D;line-height: 37px;text-align: center;margin: 50px auto;">
        赋能日化万亿市场</div>
      <div class="scList">
        <div>
          <img src="../assets/mobile/yl@2x.png" style="width: 114px;height: 90px;">
          <div
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 18px;">
            原料</div>
        </div>
        <div>
          <img src="../assets/mobile/bc@2x.png" style="width: 114px;height: 90px;margin-left: -1px;">
          <div
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 18px;">
            包材</div>
        </div>
        <div>
          <img src="../assets/mobile/wl@2x.png" style="width: 114px;height: 90px;">
          <div
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 18px;">
            物流</div>
        </div>
        <div>
          <img src="../assets/mobile/xdj@2x.png" style="width: 114px;height: 90px;">
          <div
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 18px;">
            洗涤剂</div>
        </div>
        <div>
          <img src="../assets/mobile/hzp@2x.png" style="width: 113px;height: 90px;">
          <div
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 18px;">
            化妆品</div>
        </div>
        <div>
          <img src="../assets/mobile/gd@2x.png" style="width: 113px;height: 90px;">
          <div
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 18px;">
            更多</div>
        </div>

      </div>
    </div>
    <div>
      <div
        style="font-size: 26px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #36444D;line-height: 37px;text-align: center;margin: 50px auto;">
        新闻资讯</div>
      <div style="text-align: center;">
        <img src="../assets/mobile/xwzx@2x.png" style="width: 350px;height: 262px;">
      </div>
    </div>
    <div style="padding: 0 10px;box-sizing: border-box;margin-top: 20px;">
      <van-tabs v-model:active="active" @click="onClickTab">
        <van-tab title="营销干货"></van-tab>
        <van-tab title="企业动态"></van-tab>
        <van-tab title="使用指南"></van-tab>
        <van-tab title="客户案例"></van-tab>
        <van-tab title="更多文章"></van-tab>
      </van-tabs>
      <div style="margin-top: 15px;padding-bottom: 60px;">
        <div v-for="(item, index) in article" :key="index" v-if="index <= 2" @click="toDetails(item.id)"
          style="width: 342px;height: 90px;background: #FFFFFF;box-shadow: 0px 2px 10px 0px rgba(220,221,236,0.5);border-radius: 8px;display: flex;justify-content: flex-start;margin: 10px auto 0;">
          <img :src="baseURL + item.image" alt=""
            style="width: 114px;height: 90px;background: #FFFFFF;border-radius: 8px;">
          <div style="width: 236px;padding: 10px 15px;box-sizing: border-box;">
            <div
              style="font-size: 14px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1F2329;line-height: 20px;width: 210px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
              {{item.title}}
            </div>
            <div
              style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #6D7C93;line-height: 24px;width: 210px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
              {{item.contentTitle}}
            </div>
            <div
              style="font-size: 14px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #BCC4D2;line-height: 24px;margin-top: 10px;">
              {{item.publishTime}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBanner">
      <div
        style="width: 120px;height: 40px;background: #FFFFFF;border-radius: 38px;font-size: 16px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1ED2C7;line-height: 22px;text-align: center;line-height: 40px;position: absolute;bottom: 30px;"
        @click="show = true">
        立即体验</div>
    </div>
    <div
      style="width: 100%;height: 410px;background: #F7F6FA;padding: 26px 20px;box-sizing: border-box;margin-bottom: 70px;">
      <div
        style="font-size: 16px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;line-height: 22px;padding: 6px 0;">
        友情链接</div>
      <div v-for="(item, index) in linkList" :key="index"
        style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 18px;padding: 6px 0;">
        <a :href="item.linkUrl">{{item.linkName}}</a>
      </div>
      <div
        style="font-size: 16px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;line-height: 22px;padding: 6px 0;">
        联系我们</div>
      <div
        style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 18px;padding: 6px 0;">
        Tel：{{info.mobile}}</div>
      <div
        style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 18px;padding: 6px 0;display: flex;justify-content: flex-start;">
        <div style="width: 75px;">公司地址：</div>
        <!-- <div>{{info.address}}</div> -->
      </div>
      <div style="width: 100%;height: 1px;background: #EBEAEE;margin: 10px 0 17px;"></div>
      <div>
        <img v-if="media[0].mediaType == 1" src="../assets/mobile/wx@2x.png" style="width: 27px;height: 22px;margin-right: 16px;" @click="qyQr = true">
        <a v-if="media[1].mediaType == 2" :href="media[1].url"><img src="../assets/mobile/wb@2x.png" style="width: 27px;height: 22px;"></a>

      </div>
      <div style="text-align: center;margin-top: 38px;">
        <!-- <div style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #6C7480;
    line-height: 17px;">{{info.copyright}}</div> -->
        <div
          style="font-size: 12px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #6C7480;line-height: 17px;color: #2b90fc;">
          <a href="https://beian.miit.gov.cn" style="color: #2b90fc;">备案号：{{info.websiteBa}}</a>
        </div>
      </div>
    </div>
    <!-- </v-touch> -->

    <div style="width: 100%;position: fixed;bottom: 0;left: 0;display: flex;height: 70px;" class="footer">
      <div style="background-color: #EAF2F2;color: #36444D;text-align: center;line-height: 70px;" @click="kfQr = true">
        咨询客服</div>
      <div
        style="background-color: #EAF2F2;background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);color: #FFFFFF;text-align: center;line-height: 70px;">
        <a style="color: #fff;" :href="'tel:' + info.mobile">联系我们</a></div>
    </div>
    <van-overlay :show="show" @click="show = false" z-index="100">
      <div class="block" @click.stop>
        <div class="dialogTitle">
          <div style="font-size: 20px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;line-height: 28px;">
            日化标识码申请体验预约</div>
          <div
            style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #949DC0;letter-spacing: 2px;margin-top: 5px;">
            让营销更简单，让增长更顺畅，让品质更可靠</div>
          <img src="../assets/mobile/sc_3@2x.png"
            style="width: 58px;height: 28px;position: absolute;right: 20px;bottom: -20px;z-index: 1;">
        </div>
        <div style="margin-top: 117px;">
          <div style="width: 292px;margin: 21px auto 0;">
            <div><span style="color: #CA2325;">* </span><span
                style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;color: #0A0909;line-height: 20px;">您的名字</span>
            </div>
            <van-field v-model="dynamicValidateForm.name" label="" placeholder="希望我们如何称呼您" />
          </div>
          <div style="width: 292px;margin: 21px auto 0;">
            <div><span style="color: #CA2325;">* </span><span
                style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;color: #0A0909;line-height: 20px;">手机/电话</span>
            </div>
            <van-field v-model="dynamicValidateForm.tel" label="" placeholder="顾问将于1-2个工作日内给您致电" />
          </div>
          <div style="width: 292px;margin: 21px auto 0;">
            <div><span style="color: #CA2325;">* </span><span
                style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;color: #0A0909;line-height: 20px;">企业名称</span>
            </div>
            <van-field v-model="dynamicValidateForm.enterpriseName" label="" placeholder="请提供完整的工商注册名称" />
          </div>
        </div>
        <div
          style="width: 200px;height: 45px;background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);border-radius: 26px;font-size: 16px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 45px;text-align: center;margin: 37px auto 0;"
          @click="setSubmit">
          立即体验
        </div>
        <img src="../assets/mobile/dialogRight@2x.png"
          style="width: 59px;height: 193px;bottom: 0;right: 0;position: absolute;">
        <div style="width: 100%;position: absolute;bottom: -60px;text-align: center;">
          <img src="../assets/mobile/gb@2x.png" style="width: 40px;height: 40px;" @click.stop="show = false">
        </div>
      </div>
    </van-overlay>
    <van-overlay v-show="kfQr">
      <div style="position: fixed;top: 260px;;width: 100%;height: 200px;text-align: center;">
        <div class="kfQr"
          style="width: 178px;height: 178px;border: 1px solid #00C9AD;padding: 8px 14px;box-sizing: border-box;border-radius: 8px;background: #fff;display: flex;align-items: center;justify-content: center;flex-direction: column;margin: 0 auto;">
          <div
            style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #32454E;line-height: 18px;color: #32454E;text-align: center;margin-bottom: 10px;">
            添加客服微信<br />为您一对一解答问题
          </div>
          <div>
            <img :src="baseURL + info.kfQrcode" style="width: 109px;height: 109px;">
          </div>
        </div>
        <div style="width: 100%;text-align: center;margin-top: 30px;">
          <img src="../assets/mobile/gb@2x.png" style="width: 30px;height: 30px;" @click="gb">
        </div>
      </div>
    </van-overlay>

    <van-overlay v-show="qyQr">
      <div style="position: fixed;top: 260px;;width: 100%;height: 200px;text-align: center;">
        <div class="kfQr"
          style="width: 178px;height: 178px;border: 1px solid #00C9AD;padding: 8px 14px;box-sizing: border-box;border-radius: 8px;background: #fff;display: flex;align-items: center;justify-content: center;flex-direction: column;margin: 0 auto;">
          <div
            style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #32454E;line-height: 18px;color: #32454E;text-align: center;">
            添加企业微信<br />为您一对一解答问题
          </div>
          <div>
            <img :src="baseURL + media[0].url" style="width: 109px;height: 109px;">
          </div>
        </div>
        <div style="width: 100%;text-align: center;margin-top: 30px;">
          <img src="../assets/mobile/gb@2x.png" style="width: 30px;height: 30px;" @click="gbqy">
        </div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
  import {
    getHotArticles,
    getIndex,
    getArticle,
    getLinks,
    getInfo,
    getMedia,
    submit
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  export default {
    data() {
      return {
        mk1: {},
        mk3: {},
        mk4: {},
        mk5: {},
        dynamicValidateForm: {
          name: '',
          tel: '',
          enterpriseName: ''
        },
        active: 0,
        qyQr: false,
        kfQr: false,
        show: false,
        value: '',
        isTitle: true,
        oldScrollTop: 0,
        linkList: [],
        article: [],
        info: {},
        media: [],
        baseURL: '',
        mk8: {
          moduleChildList: {}
        },
        flag: false,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
      }
    },
    created() {
      // this.indexList()
      if (screen.width > 768) {
        this.$router.push({
          path: "/"
        })
      }

    },
    mounted() {
      this.baseURL = serverUrl.baseURL
      this.setArticle()
      this.setLinks()
      this.setInfo()
      this.setMedia()
      this.setIndex()
      window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    },
    methods: {
      gbqy() {
        this.qyQr = false
      },
      gb() {
        this.kfQr = false
      },
      setSubmit() {
        if (!this.dynamicValidateForm.name) {
          return this.$toast('请填写您的名字！')
        } else if (!this.dynamicValidateForm.tel) {
          return this.$toast('请填写您的电话！')
        } else if (!this.dynamicValidateForm.enterpriseName) {
          return this.$toast('请填写您的工商注册名称！')
        } else {
          submit(this.dynamicValidateForm).then(res=> {
            this.$toast('申请成功！')
            this.show = false
            this.dynamicValidateForm = {
              name: '',
              tel: '',
              enterpriseName: ''
            }
          })

        }

      },
      setIndex() {
        getIndex().then(res => {
          this.mk1 = res.mk1
          this.mk3 = res.mk3
          this.mk4 = res.mk4
          this.mk5 = res.mk5
        })
      },
      setIndex1() {
        if (!this.flag) {
          return;
        }
        getIndex().then(res => {
          this.mk8 = res.mk8
          var that = this
          var test1 = setInterval(function() {
            that.num1 = that.num1 + 1
            if (that.mk8.moduleChildList[0].subtitle == that.num1) {
              clearInterval(test1);
            }
            console.log('执行定时器')
          }, 100)

          var test2 = setInterval(function() {
            that.num2 = that.num2 + 1
            if (that.mk8.moduleChildList[1].subtitle == that.num2) {
              clearTimeout(test2);
            }
          }, 100)
          var test3 = setInterval(function() {
            that.num3 = that.num3 + 1
            if (that.mk8.moduleChildList[2].subtitle == that.num3) {
              clearTimeout(test3);
            }
          }, 100)
          var test4 = setInterval(function() {
            that.num4 = that.num4 + 1
            if (that.mk8.moduleChildList[3].subtitle == that.num4) {
              clearTimeout(test4);
            }
          }, 100)
          var test5 = setInterval(function() {
            that.num5 = that.num5 + 1
            if (that.mk8.moduleChildList[4].subtitle == that.num5) {
              clearTimeout(test5);
            }
          }, 100)
        })
      },
      toDetails(id) {
        this.$router.push({
          path: '/MobileNewsDetails',
          query: {
            id
          }
        })
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop <= 10) {
          this.isTitle = true
        }
        if (scrollTop > 3360) {
          if (this.flag) {
            return
          } else {
            this.flag = true
            this.setIndex1()
          }

        }
        // 滚动条滚动的距离
        let scrollStep = scrollTop - this.oldScrollTop;
        console.log(scrollTop)
        // 更新——滚动前，滚动条距文档顶部的距离
        this.oldScrollTop = scrollTop;
        if (scrollStep < 0) {
          // console.log("滚动条向上滚动了！")
          this.isTitle = true
        } else {
          // console.log("滚动条向下滚动了！")
          this.isTitle = false
        }
      },
      onClickTab() {
        console.log(this.active)
        if (this.active == 4) {
          this.$router.push({
            path: '/MobileNewsList',
          })
        }
        this.setArticle()
      },
      setLinks() {
        getLinks().then(res => {
          this.linkList = res
        })
      },
      setInfo() {
        getInfo().then(res => {
          this.info = res
        })
      },
      setMedia() {
        getMedia().then(res => {
          this.media = res
        })
      },
      setArticle() {
        var id = this.active + 1
        getArticle({
          type: id
        }).then(res => {
          this.article = res.content
        })
      },
    }
  }
</script>
<style scoped>
  .banner {
    width: 100%;
    height: 500px;
    /* background: url(../assets/mobile/banner@2x.png) top center no-repeat; */
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .iconList {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 26px;
  }

  .iconList>div {
    width: 25%;
    text-align: center;
    margin-bottom: 25px;
  }

  .iconList>div div {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #36444D;
    line-height: 17px;
  }

  /deep/ .my-swipe .van-swipe-item {
    padding: 10px;
    font-size: 20px;
    box-sizing: border-box;
    height: 306px;
  }

  /deep/ .van-swipe__indicators {
    bottom: 23px;
  }

  /deep/ .van-swipe__indicator--active {
    width: 72px !important;
    height: 4px;
    border-radius: 2px;
    background-color: #00C1C7 !important;
  }

  /deep/ .van-swipe__indicator {
    height: 4px;
    background-color: #B6C2D9;
    width: 12px;
    border-radius: 2px;
  }

  .sj {
    width: 100%;
    height: 230px;
    background: url(../assets/mobile/s_bj@2x.png) top center no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .sjBanner {
    width: 339px;
    height: 383px;
    background: url(../assets/mobile/sj@2x.png) top center no-repeat;
    background-size: cover;
    position: absolute;
    top: 130px;
    padding: 28px 40px;
    box-sizing: border-box;
    box-shadow: 0px 2px 10px 0px rgba(193, 194, 224, 0.5);
    /* display: flex;
    justify-content: center;
    flex-direction: column; */
  }

  .scList {
    font-size: 0;
    width: 342px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap
  }

  .scList>div {
    position: relative;
    display: flex;
    justify-content: center;
  }

  .scList>div div {
    position: absolute;
    bottom: 10px;
  }

  /deep/ .van-tabs__line {
    background-color: #1ED2C7
  }

  /deep/ .van-tab {
    width: 100px;
    font-size: 15px;
    width: 150px;
    flex: 10;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 4px;
    color: #646566;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }

  .bottomBanner {
    width: 100%;
    height: 180px;
    background: url(../assets/mobile/bottomBanner@2x.png) top center no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .van-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 326px;
    height: 520px;
    background-color: #fff;
    border-radius: 18px;
    position: relative;
  }

  .dialogTitle {
    width: 326px;
    height: 96px;
    position: absolute;
    top: 0;
    left: 0;
    background: url(../assets/mobile/bj_3@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  /deep/ .van-cell {
    width: 292px;
    margin: 0 auto;
    border-radius: 4px;
    border: 1px solid #D7DCE3;
    margin-top: 14px;
  }

  /deep/ input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #B4BAD5 !important;
  }

  /deep/ input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #B4BAD5 !important;
  }

  /deep/ input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #B4BAD5 !important;
  }

  /deep/ input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #B4BAD5 !important;
  }

  .footer>div {
    flex: 1;
  }

  a {
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/views/MobileHome.vue